module.exports = __webpack_public_path__ + "static/media/fail.ce817db6.png";